"use strict";

angular.module("vendor")
.directive("paymentModelManagement", function() {
    return {
        bindToController: {
            statusFilter: "<?",
            statusFilterParameter: "<?",
            statusFilterService: "<",
            dateFilter: "<?",
            methodFilter: "<?",
            methodFilterParameter: "<?"
        },
        restrict: "E",
        transclude: {
            "paymentModelManagementSidebar": "?paymentModelManagementSidebar",
            "paymentModelManagementHeader": "?paymentModelManagementHeader",
            "paymentModelManagementTable": "paymentModelManagementTable"
        },
        templateUrl: require("./payment-model-management.directive.html"),
        controller: PaymentModelManagementController,
        controllerAs: "paymentModelManagementCtrl"
    };
});

function PaymentModelManagementController($scope, $state, StateExtensionService) {
    $scope.hasFilter = this.statusFilter;
    $scope.sharedScope = $scope.$new();

    $scope.statusHelpTip = $scope.service.getStatusHtmlContent();
    $scope.methodHelpTip = $scope.service.getMethodHtmlContent();
    $scope.$on("LanguageChanged", function(obj, locale, short_code) {
        $scope.statusHelpTip = $scope.service.getStatusHtmlContent();
        $scope.methodHelpTip = $scope.service.getMethodHtmlContent();
    });

    $scope.$on("statusDateFilterUpdated", function(event, statusFilter) {
        StateExtensionService.updateUrlParams(statusFilter);
        angular.extend($scope.params, statusFilter);
        $scope.$emit("clearSelection");
    });

    $scope.$on("paymentMethodFilterUpdated", function(event, methodFilter) {
        StateExtensionService.updateUrlParams(methodFilter);
        angular.extend($scope.params, methodFilter);
        $scope.$emit("clearSelection");
    });

    $scope.$on("dateFilterUpdated", function(event, dateFilter) {
        StateExtensionService.updateUrlParams(dateFilter);
        angular.extend($scope.params, dateFilter);
        $scope.$emit("clearSelection");
    });

    $scope.seePayment = function(payment) {
        $state.go("paymentDetails", {id: payment.id});
    };
}



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/model-management/payment-model-management.directive.js
// module id = 852
// module chunks = 0